// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base calendar styles */
.react-datepicker {
    font-family: inherit;
    border: none;
    box-shadow: none;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    transform: scale(0.85); 
    transform-origin: top left;
    font-size: 12px;
    width: 590px; 
    height: 280px;
  }
  
  /* Month container */
  .react-datepicker__month-container {
    float: none;
    margin: 0 10px;
    width: 300px; 
  }
  
  /* Header (month name) */
  .react-datepicker__header {
    background-color: transparent;
    border-bottom: none;
    padding: 10px 0;
  }
  
  /* Month name */
  .react-datepicker__current-month {
    font-weight: bold;
    font-size: 1.2rem;
    color: black; 
  }
  
  /* Day names (Su, Mo, etc.) */
  .react-datepicker__day-name {
    color: black;
    font-weight: 500;
    width: 40px;
    text-align: center;
  }
  
  /* Day cells */
  .react-datepicker__day {
    color: black; 
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    margin: 2px;
    border: 1px solid #D1D5DB; 
    border-radius: 4px; 
  }
  
  /* Adjacent month days */
  .react-datepicker__day--outside-month {
    color: #60a5fa; 
    /* visibility: visible !important;  */
    /* display: inline-block !important; */
    visibility: hidden;
    width: 40px;
    height: 40px;
    line-height: 40px;
  }
  
  /* Selected range */
  .react-datepicker__day--in-range {
    background-color: #EDE9FE; 
    color: black; 
    border-radius: 0 !important; 
    box-shadow: inset 0 0 0 1px #ddd; 
  }
  
  /* Start of the range */
  .react-datepicker__day--range-start {
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
    background-color: #60a5fa !important;
    color: white !important;
  }
  
  /* End of the range */
  .react-datepicker__day--range-end {
    border-top-right-radius: 8px !important;
    border-bottom-right-radius: 8px !important;
    background-color: #60a5fa !important;
    color: white !important;
  }
  
  /* Hover effect while selecting range */
  .react-datepicker__day--in-selecting-range {
    background-color: #F3F4F6 !important;
    color: #9867C5;
  }
  
  .react-datepicker__navigation {
    top: 10px;
    width: 24px; 
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.react-datepicker__navigation:hover {
    background-color: #ddd; 
}

.react-datepicker__navigation--previous {
    left: 10px;
}

.react-datepicker__navigation--next {
    right: 0px;
}
  
  
  .react-datepicker__day:hover {
    background-color: #60a5fa !important; 
    color: white !important;
  }`, "",{"version":3,"sources":["webpack://./src/component/dashboard/CallHistory/CalendarStyles.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,sBAAsB;IACtB,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,aAAa;EACf;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,cAAc;IACd,YAAY;EACd;;EAEA,wBAAwB;EACxB;IACE,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;EACjB;;EAEA,eAAe;EACf;IACE,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;EACd;;EAEA,6BAA6B;EAC7B;IACE,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA,cAAc;EACd;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA,wBAAwB;EACxB;IACE,cAAc;IACd,qCAAqC;IACrC,sCAAsC;IACtC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA,mBAAmB;EACnB;IACE,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B,gCAAgC;EAClC;;EAEA,uBAAuB;EACvB;IACE,sCAAsC;IACtC,yCAAyC;IACzC,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA,qBAAqB;EACrB;IACE,uCAAuC;IACvC,0CAA0C;IAC1C,oCAAoC;IACpC,uBAAuB;EACzB;;EAEA,uCAAuC;EACvC;IACE,oCAAoC;IACpC,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;;EAGE;IACE,oCAAoC;IACpC,uBAAuB;EACzB","sourcesContent":["/* Base calendar styles */\n.react-datepicker {\n    font-family: inherit;\n    border: none;\n    box-shadow: none;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: nowrap;\n    transform: scale(0.85); \n    transform-origin: top left;\n    font-size: 12px;\n    width: 590px; \n    height: 280px;\n  }\n  \n  /* Month container */\n  .react-datepicker__month-container {\n    float: none;\n    margin: 0 10px;\n    width: 300px; \n  }\n  \n  /* Header (month name) */\n  .react-datepicker__header {\n    background-color: transparent;\n    border-bottom: none;\n    padding: 10px 0;\n  }\n  \n  /* Month name */\n  .react-datepicker__current-month {\n    font-weight: bold;\n    font-size: 1.2rem;\n    color: black; \n  }\n  \n  /* Day names (Su, Mo, etc.) */\n  .react-datepicker__day-name {\n    color: black;\n    font-weight: 500;\n    width: 40px;\n    text-align: center;\n  }\n  \n  /* Day cells */\n  .react-datepicker__day {\n    color: black; \n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    text-align: center;\n    margin: 2px;\n    border: 1px solid #D1D5DB; \n    border-radius: 4px; \n  }\n  \n  /* Adjacent month days */\n  .react-datepicker__day--outside-month {\n    color: #60a5fa; \n    /* visibility: visible !important;  */\n    /* display: inline-block !important; */\n    visibility: hidden;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n  }\n  \n  /* Selected range */\n  .react-datepicker__day--in-range {\n    background-color: #EDE9FE; \n    color: black; \n    border-radius: 0 !important; \n    box-shadow: inset 0 0 0 1px #ddd; \n  }\n  \n  /* Start of the range */\n  .react-datepicker__day--range-start {\n    border-top-left-radius: 8px !important;\n    border-bottom-left-radius: 8px !important;\n    background-color: #60a5fa !important;\n    color: white !important;\n  }\n  \n  /* End of the range */\n  .react-datepicker__day--range-end {\n    border-top-right-radius: 8px !important;\n    border-bottom-right-radius: 8px !important;\n    background-color: #60a5fa !important;\n    color: white !important;\n  }\n  \n  /* Hover effect while selecting range */\n  .react-datepicker__day--in-selecting-range {\n    background-color: #F3F4F6 !important;\n    color: #9867C5;\n  }\n  \n  .react-datepicker__navigation {\n    top: 10px;\n    width: 24px; \n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n}\n\n.react-datepicker__navigation:hover {\n    background-color: #ddd; \n}\n\n.react-datepicker__navigation--previous {\n    left: 10px;\n}\n\n.react-datepicker__navigation--next {\n    right: 0px;\n}\n  \n  \n  .react-datepicker__day:hover {\n    background-color: #60a5fa !important; \n    color: white !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
